export const dateFormat = 'yyyy-MM-dd'; // 2000-12-30
export const datetimeFormat = 'yyyy-MM-dd hh:mm a'; // 2000-12-30 11:04 PM
